import { monthlyReportConstants } from '../_constants/monthly-report.constants';
import {
  setIsFetching,
  resetResponseDataArrays,
  filterResponseData,
  resetResponseDataObject
} from '../_utils/general.utils';

import { nanoid } from 'nanoid';

let newDate = (new Date()).toJSON();

const initialState = {
  sharedQueries: {
    date: newDate
  },
  monthlyReportTable: {
    queries: {
      sortType: 'd',
      sortKey: null,
      groupType: 'ACCOUNT_TYPE'
    },
    headers : [
      {
        header: 'ชื่อกองทุน',
        sortKey: 'fundCode'
      },
      {
        header: 'เงินลงทุน',
        sortKey: 'investmentAmount'
      },
      {
        header: 'มูลค่าปัจจุบัน',
        sortKey: 'marketAmount'
      },
      {
        header: 'ราคาทุนเฉลี่ย',
        sortKey: 'price'
      },
      {
        header: 'ราคาตลาด',
        sortKey: 'nav'
      },
      {
        header: 'P/L',
        sortKey: 'profitLoss'
      },
      {
        header: '%Port',
        sortKey: 'percentage'
      }
    ],
    responses: {
      isFetching: false,
      data: {},
      errorMessage: null
    }
  },
  monthlyReportChart: {
    cnsCategoryList: [
      {
        key: 'GMF',
        name: 'กองทั่วไป'
      },
      {
        key: 'LTF',
        name: 'LTF'
      },
      {
        key: 'RMF',
        name: 'RMF'
      },
      {
        key: 'SSF',
        name: 'SSF'
      },
      {
        key: 'SSFX',
        name: 'SSFX'
      },
      {
        key: 'TESG',
        name: 'TESG'
      }
    ],
    headers : [
      {
        header: 'เงินลงทุน',
        sortKey: 'investmentAmount'
      },
      {
        header: 'P/L',
        sortKey: 'profitLoss'
      },
      {
        header: 'มูลค่าตลาด',
        sortKey: 'marketAmount'
      },
      {
        header: '%Port',
        sortKey: 'profitLossPercentage'
      }
    ],
    chartViewList: [
      {
        key: 'CATEGORY',
        name: 'ประเภทกองทุน'
      },
      {
        key: 'FUND_LIST',
        name: 'รายกองทุน'
      },
      {
        key: 'RISK_LEVEL',
        name: 'ตามความเสี่ยง'
      },
      {
        key: 'ASSET_ALOCATE',
        name: 'ประเภทสินทรัพย์'
      }
    ],
    queries: {
      groupType: 'ACCOUNT_TYPE',
      chartView: 'CATEGORY',
      cnsCategory: []
    },
    responses: {
      isFetching: false,
      data: [],
      errorMessage: null
    }
  }
};

const monthlyReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case monthlyReportConstants.SET_MONTHLY_REPORT_SHARED_QUERIES: {
      let {key, value} = action.payload;
      let updateAttribute = {};
      updateAttribute[key] = value;

      return {
        ...state,
        sharedQueries: {
          ...state.sharedQueries,
          ...updateAttribute
        }
      };
    }
    case monthlyReportConstants.CLEAR_MONTHLY_REPORT_SHARED_QUERIES:
      return {
        ...state,
        sharedQueries: {
          accountNumber: [],
          date: newDate
        }
      };

    // Monthly Report Table
    case monthlyReportConstants.SET_MONTHLY_REPORT_TABLE_QUERIES: {
      let {key, value} = action.payload;
      let updateAttribute = {};

      switch (key) {
        case 'accountNumber': updateAttribute[key] = value; break;
        case 'sortKey': updateAttribute = {
          sortKey: value,
          sortType: value
            && value === state.monthlyReportTable.queries.sortKey
            && state.monthlyReportTable.queries.sortType !== 'a'
              ? 'a'
              : 'd'
        }; break;
        default: updateAttribute[key] = value; break;
      };

      return {
        ...state,
        monthlyReportTable: {
          ...state.monthlyReportTable,
          queries: {
            ...state.monthlyReportTable.queries,
            ...updateAttribute
          }
        }
      };
    }
    case monthlyReportConstants.FETCH_MONTHLY_REPORT_START:
      return {
        ...state,
        monthlyReportTable: {
          ...state.monthlyReportTable,
          responses: setIsFetching(state.monthlyReportTable.responses)
        }
      };
    case monthlyReportConstants.FETCH_MONTHLY_REPORT_SUCCESS:
      return {
        ...state,
        monthlyReportTable: {
          ...state.monthlyReportTable,
          responses: filterResponseData(state.monthlyReportTable, action.payload)
        }
      };
    case monthlyReportConstants.FETCH_MONTHLY_REPORT_FAILURE:
      return {
        ...state,
        monthlyReportTable: {
          ...state.monthlyReportTable,
          responses: resetResponseDataArrays(state.monthlyReportTable, action.payload)
        }
      };
    case monthlyReportConstants.CLEAR_MONTHLY_REPORT_TABLE_RESPONSES:
      return {
        ...state,
        monthlyReportTable: {
          ...state.monthlyReportTable,
          responses: resetResponseDataObject(state.monthlyReportChart.responses, action.payload)
        }
      };
    case monthlyReportConstants.CLEAR_MONTHLY_REPORT_TABLE_QUERIES:
      return {
        ...state,
        monthlyReportTable: {
          ...state.monthlyReportTable,
          queries: {
            sortType: 'd',
            sortKey: null,
            groupType: 'ACCOUNT_TYPE'
          },
        }
      };

    // Monthly Report Chart
    case monthlyReportConstants.SET_MONTHLY_REPORT_CHART_QUERIES: {
      let {key, value} = action.payload;
      let updateAttribute = {};

      switch (key) {
        case 'categories': updateAttribute[key] = value; break;
        default: updateAttribute[key] =  value; break;
      };

      return {
        ...state,
        monthlyReportChart: {
          ...state.monthlyReportChart,
          queries: {
            ...state.monthlyReportChart.queries,
            ...updateAttribute
          }
        }
      };
    }
    case monthlyReportConstants.FETCH_MONTHLY_REPORT_CHART_START:
      return {
        ...state,
        monthlyReportChart: {
          ...state.monthlyReportChart,
          responses: setIsFetching(state.monthlyReportChart.responses)
        }
      };
      case monthlyReportConstants.FETCH_MONTHLY_REPORT_CHART_SUCCESS:
        return {
          ...state,
          monthlyReportChart: {
            ...state.monthlyReportChart,
            responses: {
              ...state.responses,
              isFetching: false,
              data: action.payload
              ? action.payload.map( mainItem => ({
                  ...mainItem,
                  id: nanoid(),
                  subCategories: mainItem.subCategories.map( subItem => ({
                    ...subItem,
                    id: nanoid(),
                  }))
                }))
              : [],
              errorMessage: null
            }
          }
        };
      case monthlyReportConstants.FETCH_MONTHLY_REPORT_CHART_FAILURE:
        return {
          ...state,
          monthlyReportChart: {
            ...state.monthlyReportChart,
            responses: resetResponseDataArrays(state.monthlyReportChart.responses, action.payload)
          }
        };
    case monthlyReportConstants.CLEAR_MONTHLY_REPORT_CHART_RESPONSES:
      return {
        ...state,
        monthlyReportChart: {
          ...state.monthlyReportChart,
          responses: resetResponseDataArrays(state.monthlyReportChart.responses, null)
        }
      };
    case monthlyReportConstants.CLEAR_MONTHLY_REPORT_CHART_QUERIES:
      return {
        ...state,
        monthlyReportChart: {
          ...state.monthlyReportChart,
          queries: {
            groupType: 'ACCOUNT_TYPE',
            categories: null
          },
        }
      };
    default:
      return state;
  }
};

export default monthlyReportReducer;
